/* Sprayo CRO — dots for the phone's gallery.
   The swipe is the browser's; this only says which slide is showing. */

if (!customElements.get("sprayo-mgal")) {
  customElements.define(
    "sprayo-mgal",
    class SprayoMobileGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector("[data-sprayo-mgal-track]");
        this.dots = this.querySelector("[data-sprayo-mgal-thumbs]");
        this.slides = Array.from(this.querySelectorAll("[data-sprayo-mgal-slide]"));
        if (!this.track || !this.dots || this.slides.length < 2) return;

        this.slides.forEach((slide, i) => {
          const dot = document.createElement("button");
          dot.type = "button";
          dot.className = "sprayo-mgal__thumb";
          dot.setAttribute("aria-label", `Image ${i + 1} of ${this.slides.length}`);
          const src = slide.dataset.thumb;
          if (src) {
            const img = document.createElement("img");
            img.src = src;
            img.alt = "";
            img.loading = "lazy";
            dot.appendChild(img);
          }
          dot.addEventListener("click", () => {
            slide.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
            /* The strip scrolls too, or the chosen thumbnail can sit off the
               side of the screen once there are more than four. */
            dot.scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
          });
          this.dots.appendChild(dot);
        });
        this.dotEls = Array.from(this.dots.children);

        /* An observer rather than a scroll handler: one callback per slide
           crossing the middle, instead of one per frame of a swipe. */
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const i = this.slides.indexOf(entry.target);
              this.dotEls.forEach((d, n) => d.classList.toggle("is-active", n === i));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((s) => this.observer.observe(s));
        this.dotEls[0].classList.add("is-active");
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
